import { useHistory } from 'react-router';

export default function useRedirect() {
  const history = useHistory();

  const redirect = (url: string) => {
    const isPathName = url.startsWith('/');
    if (isPathName) {
      history.push(url);
    } else {
      window.location.assign(url);
    }
  };

  return {
    redirect,
  };
}
